import { Html } from "@react-three/drei";

const OrderButton = (props) => {
  return (
    <Html wrapperClass="wrapper" center {...props}>
      {props.visible ? (
        <button
          className="order-button"
          style={{
            marginTop: "auto",
            marginBottom: "5vh",
          }}
          onClick={() =>
            (window.location = "https://www.tesla.com/cybertruck/design")
          }
        >
          Order Now
        </button>
      ) : null}
    </Html>
  );
};

export default OrderButton;
